import { RelatorioSMSHotForm } from './component'
import React from 'react';
import Loading from "../../../components/Loading";
import Base from "../../../components/Base"
import handleError from "../../../services/apiErrorHandler";


export default class RelatorioSMSHot extends React.Component {
    render() {
        return (
            <div>

                <RelatorioSMSHotForm />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Relatorios/RelatorioSMSHot/index.js